import { render, staticRenderFns } from "./ModalUndetected.vue?vue&type=template&id=6fdc848e"
import script from "./ModalUndetected.vue?vue&type=script&lang=js"
export * from "./ModalUndetected.vue?vue&type=script&lang=js"
import style0 from "./ModalUndetected.vue?vue&type=style&index=0&id=6fdc848e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports